import { FindParams, Survey } from '@domains';
import { createAction, props } from '@ngrx/store';

export enum SurveyActionType {
  ClearSurveysFindParams = '[Surveys] Clear Surveys Find Params',
  GetSurveys = '[Surveys] Get Surveys',
  GetSurveysSuccess = '[Surveys] Get Surveys Success',

  ClearSurvey = '[Surveys] Clear Survey',
  GetSurvey = '[Surveys] Get Survey',
  GetSurveySuccess = '[Surveys] Get Survey Success',

  CreateSurvey = '[Surveys] Create Survey',
  CreateSurveySuccess = '[Surveys] Create Survey Success',

  UpdateSurvey = '[Surveys] Update Survey',
  UpdateSurveySuccess = '[Surveys] Update Survey Success',

  DeleteSurvey = '[Surveys] Delete Survey',
  DeleteSurveySuccess = '[Surveys] Delete Survey Success',

  RestoreSurvey = '[Surveys] Restore Survey',
  RestoreSurveySuccess = '[Surveys] Restore Survey Success',
}

export const clearSurveysFindParams = createAction(SurveyActionType.ClearSurveysFindParams);
export const clearSurvey = createAction(SurveyActionType.ClearSurvey);
export const getSurveys = createAction(SurveyActionType.GetSurveys, props<{ findParams: FindParams }>());
export const getSurveysSuccess = createAction(
  SurveyActionType.GetSurveysSuccess,
  props<{
    resultsCount: number;
    results: Array<Survey>;
  }>(),
);

export const getSurvey = createAction(SurveyActionType.GetSurvey, props<{ id: string }>());
export const getSurveySuccess = createAction(SurveyActionType.GetSurveySuccess, props<{ survey: Survey }>());

export const createSurvey = createAction(SurveyActionType.CreateSurvey, props<{ survey: Survey }>());
export const createSurveySuccess = createAction(SurveyActionType.CreateSurveySuccess, props<{ survey: Survey }>());

export const updateSurvey = createAction(SurveyActionType.UpdateSurvey, props<{ survey: Survey }>());
export const updateSurveySuccess = createAction(SurveyActionType.UpdateSurveySuccess, props<{ survey: Survey }>());

export const deleteSurvey = createAction(SurveyActionType.DeleteSurvey, props<{ surveyId: string }>());
export const deleteSurveySuccess = createAction(SurveyActionType.DeleteSurveySuccess, props<{ surveyId: string }>());

export const restoreSurvey = createAction(SurveyActionType.RestoreSurvey, props<{ surveyId: string }>());
export const restoreSurveySuccess = createAction(SurveyActionType.RestoreSurveySuccess, props<{ surveyId: string }>());
